<div class="div_waiter_venue">
    <div class="d-flex w-100 justify-content-center">
        <h4 class="wtr_venue_info"> {{'VENUE.MY_VENUE' | translate}}</h4>
    </div>
    <div class="w-100 mt-3  d-flex flex-wrap" style="overflow: auto;box-sizing: border-box;max-height: 100%;">
        <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
        <div *ngFor="let venues of listAllVenues" class="div_card_wtr_venue cursor-pointer">
            <div class="d-flex flex-row" (click)="navigateToVenue(venues.id)">
              <div class="pt-2 pb-2 d-flex align-items-center">
                <img class="m-2 wtr-venue-logo"
                     [src]="venues.pictureUrl ? venues.pictureUrl : imagePath"
                     alt="profile-picture">
              </div>
              <div class="ps-4">
                <label class="wtr_venue-name cursor-pointer" title="{{venues.name}}">{{venues.name}}</label>
               <label class="w_100_mobile w-60 cursor-pointer lbl-wtr_venue-value" title="{{venues.phone}}">
                <img class="pe-2" src="assets/icons/phone_bluetooth_speaker_24px.svg" alt="Phone icon"> 
                {{venues.phone}}
              </label>
                <label class="w_100_mobile w-60 cursor-pointer lbl-wtr_venue-value wtr_venue-address" title="{{venues.address}}">
                  <img class="pe-2" src="assets/icons/add_location_24px.svg" alt="Location icon">
                  {{venues.address}}</label>
              </div>
            </div>
        </div>
    </div>
</div>
